//描述：敏感词输入框校验
//作者：BaiZhiming
//时间：2016-12-7
"use strict";
angular.module("sensitiveInputModule", []).
directive("sensitiveInput", ["sensitiveWordCheckService", "$timeout", function(sensitiveWordCheckService, $timeout) {
    return {
        scope: false,
        template: "",
        restrict: 'A',
        replace: false,
        //transclude: false,
        link: function($scope, $element, iAttrs, controller) {
            initStatus();
            var status;

            function initStatus() {
                /*$scope.status.modelName = iAttrs.ngModel;*/
                status = {
                    modelName: iAttrs.ngModel,
                    name: iAttrs.ngModel.split(".")[iAttrs.ngModel.split(".").length - 1]
                };
                //当前页面所有需要校验敏感词的input
                if (angular.isUndefined($scope.status.allCheckInput)) {
                    $timeout(function() {
                        $scope.status.allCheckInput = sensitiveWordCheckService.getCheckInput();
                    }, 500);
                };
            }
            $scope.$watch(status.modelName, function(newV, oldV) {
                if (!$scope.status.isCheckSensitiveWords) return;
                checkSensitiveWord(newV);
                notifyEditorToCheck();
            });
            $scope.$watch("status.isCheckSensitiveWords", function(newV, oldV) {
                if (!$scope.status.isCheckNow && newV) {
                    checkSensitiveWord();
                    notifyEditorToCheck()
                };
                $scope.status.isCheckNow = !!newV
            });
            $scope.$on('status.notifyInputMark', function(data) {
                checkSensitiveWord();
            });
            var promise;

            function checkSensitiveWord(sensitiveWord) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function() {
                    if (angular.isDefined(sensitiveWord) && sensitiveWord === "") {
                        clearInput($element);
                        // return;
                    }
                    sensitiveWordCheckService.getAllInputSensitiveWords().then(function(data) {
                        if (data !== false) {
                            angular.forEach($scope.status.allCheckInput, function(value, key) {

                                if (data[value.checkName.toUpperCase()].length > 0) {
                                    markInput(value.field, data[value.checkName.toUpperCase()])
                                } else {
                                    clearInput(value.field);
                                }
                            });
                        } else {
                            angular.forEach($scope.status.allCheckInput, function(value, key) {
                                clearInput(value.field);
                            });
                        }
                    });
                }, 500);
                return promise;
            }

            function markInput(elem, array) {
                var tipInfo = getSensitiveWordsTip(array);
                elem.prev("span").html('<p class="validation-invalid">含有敏感词：' + tipInfo + '</p><i></i>'); //添加提示信息；
                elem.addClass("hasSensitiveWord");
                elem.parent().addClass("hasSensitiveWordInputBox");
            }

            function clearInput(elem) {
                //$element.prev().html("");
                if (elem.prev("span").html().indexOf('含有敏感词：') > -1) {
                    elem.prev("span").html('');
                };
                elem.removeClass("hasSensitiveWord");
                elem.parent().removeClass("hasSensitiveWordInputBox");
            }

            function getSensitiveWordsTip(array) {
                var tipInfo = "";
                var hash = {};
                for (var i = 0; i < array.length; i++) {
                    if (array[i].ISWORDSGROUP == '1' && !hash[array[i].WORDGROUPS]) {
                        hash[array[i].WORDGROUPS] = true;
                        tipInfo += array[i].WORDGROUPS.replace(/\[|\]/g, '') + "，";
                    } else if (array[i].ISWORDSGROUP == '0') {
                        tipInfo += array[i].SENSITIVEWORDS + "，";
                    };
                }
                tipInfo = tipInfo.substring(0, tipInfo.length - 1);
                return tipInfo;
            };
            //通知编辑器检查
            function notifyEditorToCheck() {
                $scope.$broadcast('notifyEditorToCheck');
            };
        }
    };
}]);
